import React from 'react'

const MsTeamsIcon = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' viewBox='0 0 200 186.047'>
			<path
				fill='#5059c9'
				d='M195.349 39.535a20.93 20.93 0 1 1-41.86 0 20.93 20.93 0 1 1 41.86 0zm-55.847 30.233h51.66A8.84 8.84 0 0 1 200 78.605v47.056c0 17.938-14.541 32.479-32.479 32.479h-.154c-17.938.003-32.481-14.537-32.484-32.474V74.387a4.62 4.62 0 0 1 4.619-4.619z'
			/>
			<path
				fill='#7b83eb'
				d='M149.614 69.767H64.34a8.745 8.745 0 0 0-8.526 8.944v53.67c-.673 28.941 22.223 52.957 51.163 53.665 28.94-.708 51.836-24.725 51.163-53.665v-53.67a8.744 8.744 0 0 0-8.526-8.944zm-10.079-39.535a30.233 30.233 0 0 1-60.465 0 30.233 30.233 0 0 1 60.465 0z'
			/>
			<path
				d='M111.628 69.767v75.209a8.562 8.562 0 0 1-5.302 7.86 8.228 8.228 0 0 1-3.209.651h-43.21l-1.628-4.651a56.64 56.64 0 0 1-2.465-16.465V78.698a8.73 8.73 0 0 1 8.512-8.93z'
				opacity={0.1}
			/>
			<path
				d='M106.977 69.767v79.86a8.241 8.241 0 0 1-.651 3.209 8.563 8.563 0 0 1-7.86 5.302H62.093l-2.186-4.651a46.13 46.13 0 0 1-1.628-4.651 56.647 56.647 0 0 1-2.465-16.465V78.698a8.73 8.73 0 0 1 8.512-8.93z'
				opacity={0.2}
			/>
			<path
				d='M102.326 69.767v70.558a8.58 8.58 0 0 1-8.512 8.512H58.279a56.647 56.647 0 0 1-2.465-16.465V78.698a8.73 8.73 0 0 1 8.512-8.93z'
				opacity={0.2}
			/>
			<path
				d='M111.628 45.721v14.651l-2.326.093c-.791 0-1.535-.046-2.326-.093a25.497 25.497 0 0 1-4.651-.744 30.233 30.233 0 0 1-20.93-17.767 25.845 25.845 0 0 1-1.488-4.651h23.209a8.545 8.545 0 0 1 8.512 8.512z'
				opacity={0.1}
			/>
			<use xlinkHref='#a' opacity={0.2} transform='scale(.08973)' />
			<path
				d='M106.977 50.372v10a25.497 25.497 0 0 1-4.651-.744 30.233 30.233 0 0 1-20.93-17.767h17.07a8.545 8.545 0 0 1 8.512 8.512zm0 19.395v70.558a8.58 8.58 0 0 1-8.512 8.512H58.279a56.647 56.647 0 0 1-2.465-16.465V78.698a8.73 8.73 0 0 1 8.512-8.93z'
				opacity={0.2}
			/>
			<path d='M102.326 50.372v9.256a30.233 30.233 0 0 1-20.93-17.767h12.419a8.545 8.545 0 0 1 8.512 8.512z' opacity={0.2} />
			<linearGradient id='b' x1={17.776} x2={84.55} y1={35.199} y2={150.848} gradientUnits='userSpaceOnUse'>
				<stop offset={0} stopColor='#5a62c3' />
				<stop offset={0.5} stopColor='#4d55bd' />
				<stop offset={1} stopColor='#3940ab' />
			</linearGradient>
			<path
				fill='url(#b)'
				d='M8.526 41.86H93.8a8.53 8.53 0 0 1 8.526 8.526v85.274a8.53 8.53 0 0 1-8.526 8.526H8.526A8.53 8.53 0 0 1 0 135.66V50.386a8.53 8.53 0 0 1 8.526-8.526z'
			/>
			<path fill='#fff' d='M73.6 74.316H56.553v46.419h-10.86V74.316H28.726v-9.005H73.6z' />
			<defs>
				<path
					id='a'
					d='M1192.167 561.355v111.442a284.472 284.472 0 0 1-51.833-8.293 336.92 336.92 0 0 1-233.25-198.003h190.228c52.304.198 94.656 42.55 94.855 94.854z'
				/>
			</defs>
		</svg>
	)
}

export default MsTeamsIcon
